import { getDocByUID, getDocs } from "shared/prismic";
import { ReviewsPage } from "containers/ReviewsPage";
import { getReviews } from "shared-server/firebase";

export async function getStaticProps({
  preview = null,
  previewData,
  params: { uid },
}) {
  const reviews = await getReviews(uid);
  const doc = await getDocByUID({ previewData, uid, type: "course_detail" });
  return { props: { doc, staticReviews: reviews || [], preview } };
}

export async function getStaticPaths() {
  const pages = await getDocs({ type: "course_detail" });
  const paths = pages.map(({ uid }) => ({ params: { uid } }));
  return { paths, fallback: false };
}

export default ReviewsPage;
